import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Api from './Api';
import Background2 from './assets/background2.png';

function SSoft_Help_Hero() {
  const [sectionItems, setSectionItems] = useState([]);
  const activeLang = useSelector((state) => state.content.activeLanguage);

  useEffect(() => {
    const fetchData = async () => {
      const api = new Api();
      const sectionResponse = await api.getSectionDetail({ language: activeLang });
      const sectionData = sectionResponse;

      setSectionItems(sectionData.data.results[0]);
    };

    fetchData();
  }, [activeLang]);

  let background;
  let title;  
  if (sectionItems) {
    const secWidgets = sectionItems.widgets;
  
    if (secWidgets) {
      secWidgets?.forEach((data, id) => {
        switch (id) {
          case 0:
            background = data.widget_contents[0]?.file_medium;
            break;
          case 1:
            title = data.widget_contents[0]?.content;
            break;
          default:
            break;
        }
      });
    }
  }

  return (
    <div 
      className='w-full min-h-[430px]' 
      style={{
        backgroundImage: `url(${background && background})`, 
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}>
      <div className='section-container w-full min-h-[430px] flex justify-center items-center'>
        <h1 className='text-cuzWhite text-7xl font-bold leading-[100%]'>{title && title}</h1>
      </div>
    </div>
  )
}

export default SSoft_Help_Hero